import createConverter from './lib/create_converter';
import Conversation from 'models/conversation';

export default createConverter(Conversation);
